import { render } from "./VmsSidebarCamerasTabGroupDialog.vue?vue&type=template&id=3925e594&ts=true"
import script from "./VmsSidebarCamerasTabGroupDialog.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTabGroupDialog.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTabGroupDialog.vue?vue&type=style&index=0&id=3925e594&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__